module.exports = __webpack_public_path__ + "img/super-bundles.239586b.png";